import { string, object } from "yup";

export const archiveDescriptionSchema = object().shape({
  desc: string().max(512, "Description must be at most ${max} characters"),
});
